"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getEvaluation = getEvaluation;
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Star = _interopRequireDefault(require("@material-ui/icons/Star"));

var _StarHalf = _interopRequireDefault(require("@material-ui/icons/StarHalf"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _strings = require("../Voting/strings");

function getEvaluation(votes) {
  var totalVotes = votes.reduce(function (acc, cur) {
    return acc + cur;
  }, 0);
  var totalValues = votes.reduce(function (acc, cur, index) {
    return cur * (index + 1) + acc;
  }, 0);
  var middleValue = totalValues / totalVotes;
  return {
    totalVotes: totalVotes,
    middleValue: middleValue.toFixed(2)
  };
}

function RatingFeedbackView(_ref) {
  var feedback = _ref.feedback,
      ratings = _ref.ratings;
  var votes = ratings.map(function (id) {
    return feedback.hasOwnProperty(id) ? feedback["".concat(id, "_abs")] : 0;
  });

  var _getEvaluation = getEvaluation(votes),
      totalVotes = _getEvaluation.totalVotes,
      middleValue = _getEvaluation.middleValue;

  var middleValueString = middleValue.toString();

  var _middleValueString$sp = middleValueString.split('.'),
      _middleValueString$sp2 = (0, _slicedToArray2["default"])(_middleValueString$sp, 2),
      _int = _middleValueString$sp2[0],
      digits = _middleValueString$sp2[1];

  var intNumber = Number(_int);
  var digitsNumber = Number(digits);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, ratings.map(function (rating) {
    if (rating - 1 === intNumber && digitsNumber >= 25 && digitsNumber < 75) {
      return /*#__PURE__*/_react["default"].createElement(_StarHalf["default"], {
        color: "primary",
        key: rating
      });
    }

    if (intNumber >= rating) {
      return /*#__PURE__*/_react["default"].createElement(_Star["default"], {
        color: "primary",
        key: rating
      });
    }

    return /*#__PURE__*/_react["default"].createElement(_Star["default"], {
      color: "disabled",
      key: rating
    });
  }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    variant: "body1"
  }, (0, _strings.getString)('TOTAL_VOTES'), ": ", totalVotes));
}

RatingFeedbackView.propTypes = {
  feedback: _propTypes["default"].object,
  ratings: _propTypes["default"].array
};
var _default = RatingFeedbackView;
exports["default"] = _default;